// Capture the `nlhash` marketing-email token from the URL into a cookie so it can
// be forwarded to the API as the X-Nl-Hash header on cart writes (see
// plugins/fetch-with-token.ts). The token is opaque — stored verbatim, never decoded
// or transformed. Newer recipient links overwrite older ones.
//
// Handles the no-login case: a `?nlhash` link with no `?login` is not redirected by
// server/middleware/token-login.ts, so the param reaches the client. The auto-login
// case (`?login&nlhash`) is captured server-side in that middleware before it strips
// the param.
//
// (nlaction email tracking is handled separately in server/middleware/nlaction.ts.)
export default defineNuxtPlugin(() => {
  const route = useRoute()
  const router = useRouter()
  const cookie = useCookie<string | null>('nlhash', {
    path: '/',
    sameSite: 'lax',
    maxAge: 60 * 60 * 24 * 30, // 30 days
    secure: !import.meta.dev,
  })

  const capture = (q: Record<string, any>) => {
    if (q?.nlhash) cookie.value = String(q.nlhash)
  }

  capture(route.query) // entry URL (email link)
  router.afterEach(to => capture(to.query)) // later client-side navigations
})
